export const GENERIC_PROPERTY_PREFIX = 'prop'
export const MAX_GENERIC_PROPERTIES = 100
